export default {
  createPlan: 'Criar Plano',
  noModelsAvailable: 'Não há modelos disponíveis. Crie o primeiro ou fale com o administrador.',
  search: 'Buscar',
  loading: 'Carregando...',
  noPlansAvailable: 'Não há planos disponíveis para este modelo',
  running: 'Executando...',
  headerName: 'Nome',
  headerBudget: 'Orçamento ({unit})',
  upTo: 'até {value}',
  headerPredicted: '{kpiName} Projetadas ({unit})',
  headerPeriod: 'Período',
  headerCreated: 'Criado',
  defaultKpiName: 'Vendas',
  defaultCurrency: 'USD',
  sharedWithExternalUsers: 'Compartilhado com usuários externos',
  betaOptimizerTooltip: 'Este plano usa o novo otimizador (beta)',
  createFromScratch: 'Do Zero',
  createLastYearActualBudget: 'Ano Anterior, Orçamento Real (Strategy Check)',
  createLastYearSaturationBudget: 'Ano Anterior, Orçamento atingindo Saturação Total de Diminishing Returns',
  createNextYearBudgetPropagation: 'Ano Seguinte, Propagação de Orçamento Real (Forward Looking)',
  chooseFromScratchDescription: 'Defina você o período, o orçamento e as restrições, e deixe o otimizador distribuir o investimento.',
  chooseActualBudgetTitle: 'Orçamento Real do Ano Anterior',
  chooseActualBudgetDescription: 'Otimiza o investimento total dos últimos 12 meses de dados nesse mesmo período.',
  chooseSaturationTitle: 'Ano Anterior em Saturação',
  chooseSaturationDescription: 'Otimiza o orçamento com o qual cada canal atinge a saturação total de diminishing returns nos últimos 12 meses.',
  chooseNextYearTitle: 'Propagação de Orçamento do Ano Seguinte',
  chooseNextYearDescription: 'Otimiza o orçamento que o modelo propaga para o próximo ano.',
  chooseTagStrategyCheck: 'Strategy Check',
  chooseTagSaturation: 'Saturação',
  chooseTagForwardLooking: 'Forward Looking',
  createFlexibleDates: 'Datas Flexíveis',
  chooseFlexibleTitle: 'Datas Flexíveis',
  chooseTagFlexible: 'Flexível',
  flexibleSummaryActual: 'Investimento real',
  flexibleSummaryPropagation: 'Propagação de orçamento',
  flexibleSummaryEmpty: 'Sem dados, soma 0',
  flexibleMonths: '{count} mês | {count} meses',
  flexibleWeeks: '{count} semana | {count} semanas',
  flexibleHintActual: 'Há investimento real disponível até {date}.',
  flexibleHintPropagation: 'A propagação de orçamento cobre de {from} a {to}.',
  chooseFlexibleDescription: 'Escolha qualquer período: seu orçamento soma o investimento real onde o modelo o tem e a propagação de orçamento depois.',
  flexibleSummaryTotal: 'Orçamento',
  chooseNeedsMediaSpend: 'Requer dados de investimento em mídia no relatório do modelo',
  channelMismatchTitle: 'Os canais do modelo mudaram',
  channelMismatchIntro: 'Os canais de mídia deste modelo não correspondem mais aos deste plano, provavelmente porque o modelo foi atualizado após a criação do plano. Se você continuar, o plano usará os canais atuais do modelo.',
  channelMismatchRemoved: 'Canais do plano que não existem mais no modelo (o investimento deles será descartado):',
  channelMismatchProceedAnyway: 'Continuar mesmo assim',
  channelMismatchCancel: 'Cancelar'
}
